import React from "react";
import RnProtocol from "../../components/RN/RnProtocol";
import HhaProtocol from "../../components/HHA/HhaProtocol";
import LvnProtocol from "../../components/Lvn/LvnProtocol";
import PtProtocol from "../../components/PT/PtProtocol";
import PtaProtocol from "../../components/PTA/PtaProtocol";
import OtProtocol from "../../components/OT/OtProtocol";
import OtaProtocol from "../../components/OTA/OtaProtocol";
import MswProtocol from "../../components/MSW/MswProtocol";
import StProtocol from "../../components/St/StProtocol";
const PROTOCOL_COMPONENTS = {
  hha: HhaProtocol,
  rn: RnProtocol,
  registerednurse: RnProtocol,
  lvn: LvnProtocol,
  licensedvocationalnurse: LvnProtocol,
  pt: PtProtocol,
  physicaltherapist: PtProtocol,
  pta: PtaProtocol,
  physicaltherapistassistant: PtaProtocol,
  ot: OtProtocol,
  occupationaltherapist: OtProtocol,
  ota: OtaProtocol,
  certifiedoccupationaltherapyassistant: OtaProtocol,
  msw: MswProtocol,
  medicalsocialworker: MswProtocol,
  st: StProtocol,
};

const ProtocolRenderer = ({ positionId, targetUserId, onClose }) => {
  // Normalize positionId (lowercase, remove spaces)
  const normalizedId = positionId?.toLowerCase().replace(/\s+/g, "");

  // Support normalized lookup and fallback to RN
  const Component =
    PROTOCOL_COMPONENTS[normalizedId] || PROTOCOL_COMPONENTS["rn"];


  if (!Component) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto bg-gray-100">
      <Component targetUserId={targetUserId} onClose={onClose} />
    </div>
  );
};

export default ProtocolRenderer;
